<template>
    <div v-if="runningExport !== null">
        <template v-if="runningExport.status < -1">
            <slot name="error">
                <div class="alert alert-danger">
                    Für den verwendeten Token {{ runningExport.hash }} wurde kein Dokument freigegeben oder der Freigabezeitraum ist abgelaufen.
                </div>
            </slot>
        </template>

        <template v-else-if="runningExport.status < 0">
            <slot name="error">
                <div class="alert alert-danger">
                    {{ runningExport.message ? runningExport.message : 'Beim erzeugen des Dokuments ist ein unerwarteter Fehler aufgetreten.' }}
                </div>
            </slot>
        </template>

        <template v-else-if="runningExport.status < 2">
            <slot name="progress" :progress="runningExport.progress">
                <p>Dokument wird generiert... {{ runningExport.progress }}%</p>
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" :style="{width: runningExport.progress+'%'}"></div>
                </div>
            </slot>
        </template>

        <template v-else>
            <slot name="success" :download-export="downloadExport">
                <div class="alert alert-success">
                    <p>Das Dokument kann nun heruntergeladen werden.</p>
                    <btn theme="success" size="sm" icon="download" label="Download starten" @click="downloadExport"/>
                </div>
            </slot>
        </template>
    </div>
</template>

<script>
    export default {
        
        props: {
            idOrHash: [Number, String],
        },
        
        data() {
            return {
                runningExport: null,
            };
        },

        methods: {
            async fetchExport() {
                this.runningExport = await this.$store.dispatch('user/getExport', this.idOrHash);
                if (this.runningExport.status !== 2 && this.runningExport.status >= 0) {
                    setTimeout(this.fetchExport, 1000);
                }
            },

            downloadExport() {
                window.open(this.runningExport.url, '_blank');
            },
        },

        mounted() {
            this.fetchExport();
        },
    };
</script>